module.exports = __webpack_public_path__ + "static/media/Unarchive.fb931a60.svg";